const configService = {
    baseUrl: process.env.VUE_APP_API_URL + '/images/'
};

export default configService;
